import { useContext } from "react";
import { Link } from "react-router-dom";
import ExternalLink from "../../../assets/externalLink";
import { Context, IContext } from "../../../context/ContextApp";
import { subdomainTypes } from "../../../context/availableSubdomains";
import { ILinkInfo, subMenuBranchLink, subMenuLinks } from "./data";

interface Props {
  jwt: string;
}

const SublimationSubMenu = ({ jwt }: Props) => {
  const sublimationWebsite = process.env.REACT_APP_SUBLIMATION_WEBSITE;
  const { appBranch }: IContext = useContext(Context);
  const toolLinks = subMenuLinks.filter((link) => link.title !== "Design Your Way");

  const generateSubMenuLink = (category: ILinkInfo) => {
    const link = category.isExternalLink
      ? category.targetLink
      : `${sublimationWebsite}${category.targetLink}?jwt=${jwt}`;

    const getPricingLink = (appBranch: subdomainTypes | string, subLink: subMenuBranchLink) => {
      return appBranch === subdomainTypes.NZ ? subLink.nz : subLink.au;
    };

    return (
      <>
        <Link to="" onClick={() => window.open(link, "_blank")}>
          <span style={{ textTransform: "capitalize" }}>{category.title}</span>
          <div className="expand-icon">
            <ExternalLink width={15} fill="white" />
          </div>
        </Link>

        {category.subMenuLink?.map((subLink, index) => {
          const href = getPricingLink(appBranch, subLink);
          return (
            <a key={index} href={href} target="_blank" rel="noreferrer">
              <span className="submenu-links" style={{ marginLeft: "15px" }}>
                {subLink.title}
              </span>
            </a>
          );
        })}
      </>
    );
  };

  const generateSubmenu = (): JSX.Element | JSX.Element[] =>
    toolLinks.map((category, index) => (
      <div key={index} role="menuitem">
        {generateSubMenuLink(category)}
      </div>
    ));

  return <>{generateSubmenu()}</>;
};

export default SublimationSubMenu;
